import { PlayArrow, PlayCircle } from "@mui/icons-material";

const playIconStyles = {
  width: (theme: any) => theme.spacing(6),
  height: (theme: any) => theme.spacing(6),
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  pointerEvents: "none" as const,
};

const PlayOverlay = () => (
  <>
    <PlayCircle sx={{ ...playIconStyles, color: "primary.main" }} />
    <PlayArrow
      sx={{ ...playIconStyles, p: 1, color: "common.white" }}
      fontSize="small"
    />
  </>
);

export default PlayOverlay;
